"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestartLayer = void 0;
var GameConstants_1 = require("./../../../GameConstants");
var BoardManager_1 = require("./../BoardManager");
var GameManager_1 = require("./../../../GameManager");
var GameVars_1 = require("../../../GameVars");
var Utils_1 = require("../../../utils/Utils");
var BoardScene_1 = require("../BoardScene");
var AudioManager_1 = require("../../../AudioManager");
var RestartLayer = /** @class */ (function (_super) {
    __extends(RestartLayer, _super);
    function RestartLayer(scene) {
        var _this = _super.call(this, scene) || this;
        var shape = new Phaser.GameObjects.Shape(_this.scene);
        shape.width = GameVars_1.GameVars.gameWidth;
        shape.height = GameVars_1.GameVars.gameHeight;
        shape.x = 0;
        shape.y = 0;
        var darkBackground = new Phaser.GameObjects.Graphics(_this.scene);
        darkBackground.fillStyle(0x321B38);
        darkBackground.fillRect(0, 0, GameVars_1.GameVars.gameWidth, GameVars_1.GameVars.gameHeight);
        darkBackground.alpha = .6;
        darkBackground.setInteractive(shape, _this.onDownBackground);
        _this.add(darkBackground);
        var width = 540;
        var height = 1000 * GameVars_1.GameVars.scaleY;
        var x = GameVars_1.GameVars.gameWidth / 2 - width / 2;
        var y = GameVars_1.GameVars.gameHeight / 2 - height / 2 + 40 * GameVars_1.GameVars.scaleY;
        RestartLayer.pointerRect = {
            x: x,
            y: y,
            width: width,
            height: height
        };
        var scaledItemsContainer = new Phaser.GameObjects.Container(_this.scene, GameVars_1.GameVars.gameWidth / 2, GameVars_1.GameVars.gameHeight / 2);
        scaledItemsContainer.setScale(.9, .9 * GameVars_1.GameVars.scaleY);
        _this.add(scaledItemsContainer);
        var frame = new Phaser.GameObjects.Image(_this.scene, 0, 0, "texture_atlas_1", "layout");
        scaledItemsContainer.add(frame);
        var cell = new Phaser.GameObjects.Image(_this.scene, 0, -170, "texture_atlas_1", "shop_cell");
        scaledItemsContainer.add(cell);
        var resetText = new Phaser.GameObjects.Text(_this.scene, 0, -170, GameVars_1.GameVars.gameText[GameVars_1.GameVars.language]["RESTART_1"], { fontFamily: "Baloo", fontSize: "30px", color: "#95573f", align: "center" });
        resetText.setOrigin(.5);
        resetText.setWordWrapWidth(420);
        scaledItemsContainer.add(resetText);
        cell = new Phaser.GameObjects.Image(_this.scene, 0, -40, "texture_atlas_1", "shop_cell");
        scaledItemsContainer.add(cell);
        var imgArrow = new Phaser.GameObjects.Image(_this.scene, 0, -40, "texture_atlas_1", "arrow_boost");
        scaledItemsContainer.add(imgArrow);
        var textureAtlas = GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? "texture_atlas_2" : "texture_atlas_3";
        var frameName = GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? "cake_" : "biscuits_";
        var imgCake = new Phaser.GameObjects.Image(_this.scene, -150, -40, textureAtlas, frameName + (GameVars_1.GameVars.modeGameData.restartCounter + 1));
        imgCake.setScale(.35);
        scaledItemsContainer.add(imgCake);
        imgCake = new Phaser.GameObjects.Image(_this.scene, 150, -40, textureAtlas, frameName + (GameVars_1.GameVars.modeGameData.restartCounter + 2));
        imgCake.setScale(.35);
        scaledItemsContainer.add(imgCake);
        resetText = new Phaser.GameObjects.Text(_this.scene, -4, -44, GameVars_1.GameVars.gameText[GameVars_1.GameVars.language]["RESTART_2"], { fontFamily: "Baloo", fontSize: "28px", color: "#FFFFFF", align: "center" });
        resetText.setOrigin(.5);
        scaledItemsContainer.add(resetText);
        cell = new Phaser.GameObjects.Image(_this.scene, 0, 90, "texture_atlas_1", "shop_cell");
        scaledItemsContainer.add(cell);
        resetText = new Phaser.GameObjects.Text(_this.scene, 0, 86, GameVars_1.GameVars.gameText[GameVars_1.GameVars.language]["RESTART_3"], { fontFamily: "Baloo", fontSize: "28px", color: "#FFFFFF", align: "center" });
        resetText.setOrigin(.5);
        resetText.setWordWrapWidth(410);
        scaledItemsContainer.add(resetText);
        cell = new Phaser.GameObjects.Image(_this.scene, 0, 220, "texture_atlas_1", "shop_cell");
        scaledItemsContainer.add(cell);
        resetText = new Phaser.GameObjects.Text(_this.scene, 0, 216, GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? GameVars_1.GameVars.gameText[GameVars_1.GameVars.language]["RESTART_4_1"] : GameVars_1.GameVars.gameText[GameVars_1.GameVars.language]["RESTART_4_2"], { fontFamily: "Baloo", fontSize: "28px", color: "#FFFFFF", align: "center" });
        resetText.setOrigin(.5);
        resetText.setWordWrapWidth(410);
        scaledItemsContainer.add(resetText);
        var titleBackground = new Phaser.GameObjects.Image(_this.scene, 0, -320, "texture_atlas_0", "title_cookie_base");
        scaledItemsContainer.add(titleBackground);
        var title = new Phaser.GameObjects.Image(_this.scene, 0, titleBackground.y, "texture_atlas_1", "title_restart");
        scaledItemsContainer.add(title);
        var resetButton = new Utils_1.Button(_this.scene, 0, 315, "texture_atlas_1", "btn_reset_off", "btn_reset_on");
        resetButton.setScale(1.5);
        resetButton.onDown(_this.onClickReset, _this);
        scaledItemsContainer.add(resetButton);
        _this.alpha = 0;
        _this.scene.tweens.add({
            targets: _this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350,
            delay: 500
        });
        return _this;
    }
    RestartLayer.prototype.onClickReset = function () {
        BoardManager_1.BoardManager.restartMode();
    };
    RestartLayer.prototype.onDownBackground = function (shape) {
        if (BoardScene_1.BoardScene.currentInstance.input.activePointer.isDown) {
            var x = BoardScene_1.BoardScene.currentInstance.input.activePointer.x;
            var y = BoardScene_1.BoardScene.currentInstance.input.activePointer.y;
            var insideRect = false;
            var rect = RestartLayer.pointerRect;
            if (x > rect.x && x < rect.x + rect.width && y > rect.y && y < rect.y + rect.height) {
                insideRect = true;
            }
            if (!insideRect) {
                BoardManager_1.BoardManager.hideRestartLayer();
                GameManager_1.GameManager.updateLastPlayerAction();
            }
            AudioManager_1.AudioManager.playSound("click_button");
        }
    };
    return RestartLayer;
}(Phaser.GameObjects.Container));
exports.RestartLayer = RestartLayer;
